export default {
    apiGetCareers(data) {
        return this.request(this.api().getCareers, data)
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    },
    apiGetJobsList(data) {
        return this.request(this.api().getJobsList, data)
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    },
    apiGetJobRoles(data = {}) {
        return this.request(this.api().getJobRoles, data)
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    },
    apiGetJobLocations(data = {}) {
        return this.request(this.api().getJobLocations, data)
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    },
    apiGetJobExperience(data = {}) {
        return this.request(this.api().getJobExperience, data)
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    },
    apiGetCareerById(data) {
        return this.request(this.api().getCareerById, data)
            .urltransform(data)
            .exec()
            .mapresults((res) => res)
            .get();
    },
    apiCreateCareer(data) {
        return this.request(this.api().createCareer, data)
            .urltransform(data)
            .exec()
            .mapresults((res) => res)
            .get();
    },
    apiUpdateCareer(data, urldata = {}) {
        return this.request(this.api().updateCareer, data)
            .urltransform(urldata)
            .exec()
            .mapresults((res) => res)
            .get();
    },
    apiPatchCareerStatus(data, urldata = {}) {
        return this.request(this.api().patchCareerStatus, data)
            .urltransform(urldata)
            .exec()
            .mapresults((res) => res)
            .get();
    },
    apiDeleteCareer(data, urldata = {}) {
        return this.request(this.api().deleteCareer, data)
            .urltransform(urldata)
            .exec()
            .mapresults((res) => res)
            .get();
    }
};
